import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { companyTypes } from '../CompanyTypes';

export const useCompanyTypes = () =>
  useQuery({
    queryKey: [QUERY_KEYS.companyTypes],
    queryFn: async () => (await companyTypes.getCompanyTypes()).data,
  });
